import './style.scss';
import { useEffect, useState } from 'react';
import { webStorageUtil } from 'state/webStorage.state.service';
import { ELocalStorageKeys } from '../../constants/enums';
import FontPreviewList from './components/FontPreviewList';

const DevDialog = ({ onClose }: { onClose: () => void }) => {
  const [offersApiOverride, setOffersApiOverride] = useState(
    webStorageUtil.get(ELocalStorageKeys.OFFER_API_OVERRIDE)
  );
  const [bootApiOverride, setBootApiOverride] = useState(
    webStorageUtil.get(ELocalStorageKeys.BOOT_API_OVERRIDE)
  );
  const [overrideStore, setOverrideStore] = useState(
    webStorageUtil.get(ELocalStorageKeys.OVERRIDE_STORE)
  );

  const [overrideInput, setOverrideInput] = useState('');

  const [selectedOption, setSelectedOption] = useState('appcharge');

  useEffect(() => {
    const domain = selectedOption === 'appcharge' ? '.appcharge.com' : '.appchargestore.com';
    const url = overrideInput + domain;
    setOverrideStore(!overrideInput.trim() ? '' : url);
  }, [overrideInput, selectedOption]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSelectedOption(event.target.value);

  const onSave = () => {
    offersApiOverride &&
      webStorageUtil.set(
        ELocalStorageKeys.OFFER_API_OVERRIDE,
        JSON.stringify(JSON.parse(offersApiOverride))
      );
    bootApiOverride &&
      webStorageUtil.set(
        ELocalStorageKeys.BOOT_API_OVERRIDE,
        JSON.stringify(JSON.parse(bootApiOverride))
      );
    overrideStore && webStorageUtil.set(ELocalStorageKeys.OVERRIDE_STORE, overrideStore);
    window.location.reload();
  };

  const onClear = () => {
    const p = window.prompt('Are you sure?');
    if (p) {
      webStorageUtil.remove(ELocalStorageKeys.OFFER_API_OVERRIDE);
      webStorageUtil.remove(ELocalStorageKeys.BOOT_API_OVERRIDE);
      webStorageUtil.remove(ELocalStorageKeys.OVERRIDE_STORE);
      window.location.reload();
    }
  };

  return (
    <dialog aria-hidden="true" open>
      <code>🤖 Dev Panel 🤖</code>
      <div style={{ marginTop: 16, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
        <strong>Override Store</strong>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <input value={overrideInput} onChange={(e) => setOverrideInput(e.target.value)} />
          <input
            type="radio"
            value="appcharge"
            checked={selectedOption === 'appcharge'}
            onChange={handleCheckboxChange}
          />{' '}
          .appcharge.com
          <input
            type="radio"
            value="appchargestore"
            checked={selectedOption === 'appchargestore'}
            onChange={handleCheckboxChange}
          />{' '}
          .appchargestore.com
        </div>
      </div>
      <div style={{ marginTop: 16, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
        <strong>{'Override GET Offer API'}</strong>
        <textarea
          placeholder={'JSON goes here'}
          rows={5}
          onChange={(e) => setOffersApiOverride(e.target.value)}
        >
          {offersApiOverride}
        </textarea>
      </div>
      <div style={{ marginTop: 16, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
        <strong>Override GET Boot API</strong>
        <textarea
          placeholder={'JSON goes here'}
          rows={5}
          onChange={(e) => setBootApiOverride(e.target.value)}
        >
          {bootApiOverride}
        </textarea>
      </div>
      <FontPreviewList />
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 16,
          width: '100%',
        }}
      >
        <button style={{ cursor: 'pointer', fontSize: '2em' }} onClick={() => onSave()}>
          {'SAVE'} 👌
        </button>
        <button
          style={{ cursor: 'pointer', fontSize: '2em', opacity: 0.5 }}
          onClick={() => onClear()}
        >
          {'CLEAR'} 🗑️
        </button>
      </div>
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <button type="button" onClick={() => onClose()}>
          {'Close'}
        </button>
      </div>
    </dialog>
  );
};

export default DevDialog;
